import './RankingsBoxFilters.css'

import classNames from 'classnames'
import { InputDropdown } from 'components'
import PropTypes from 'prop-types'
import React from 'react'
import { withTranslation } from 'react-i18next'

import Box from '@mui/material/Box'

import { RANKINGS } from './constants'
import FilterCountryModalContainer from './FilterCountryModalContainer'
import { getColumnsPerRanking, getLabelPerColumn } from './utils'

class RankingsBoxFilters extends React.PureComponent {
  render() {
    const {
      areFiltersExpanded,
      countries,
      fetchCountries,
      hideFilterCountryModal,
      indicator,
      isModalOpen,
      openFilterCountryModal,
      ranking,
      selectedCountriesCount,
      setIndicator,
      setRanking,
      t,
      toggleAreFiltersExpanded,
      userPrivileges,
    } = this.props
    const rankingOptions = [
      {
        label: t('rankings.companiesStationary'),
        privilege: userPrivileges.rankingsCompaniesStationaryVisibility,
        value: RANKINGS.COMPANIES_STATIONARY,
      },
      {
        label: t('rankings.companiesByChannels'),
        privilege: userPrivileges.rankingsCompaniesByChannelsVisibility,
        value: RANKINGS.COMPANIES_BY_CHANNELS,
      },
      {
        label: t('rankings.companiesEcommerce'),
        privilege: userPrivileges.rankingsCompaniesEcommerceVisibility,
        value: RANKINGS.COMPANIES_ECOMMERCE,
      },
      {
        label: t('rankings.companiesClubCard'),
        privilege: userPrivileges.rankingsCompaniesClubCardVisibility,
        value: RANKINGS.CLUB_CARD,
      },
      {
        label: t('rankings.websiteEcommerce'),
        privilege: userPrivileges.rankingsWebsiteEcommerceVisibility,
        value: RANKINGS.WEBSITE_ECOMMERCE,
      },
      {
        label: t('rankings.best20Shops'),
        privilege: userPrivileges.rankingsBest20ShopsVisibility,
        value: RANKINGS.BEST_20_SHOPS,
      },
      {
        label: t('rankings.worst20Shops'),
        privilege: userPrivileges.rankingsWorst20ShopsVisibility,
        value: RANKINGS.WORST_20_SHOPS,
      },
      {
        label: t('rankings.district'),
        privilege: userPrivileges.rankingsDistrictVisibility,
        value: RANKINGS.DISTRICT,
      },
      {
        label: t('rankings.rks'),
        privilege: userPrivileges.rankingsRKSVisibility,
        value: RANKINGS.RKS,
      },
      {
        label: t('rankings.storesOpenWithin30Days'),
        privilege: userPrivileges.rankingsStoresOpenWithin30DaysVisibility,
        value: RANKINGS.STORES_OPEN_WITHIN_30_DAYS,
      },
      {
        label: t('rankings.storesOpenWithin12Months'),
        privilege: userPrivileges.rankingsStoresOpenWithin12MonthsVisibility,
        value: RANKINGS.STORES_OPEN_WITHIN_12_MONTHS,
      },
      {
        label: t('rankings.hoursRevenue'),
        value: RANKINGS.HOURS_REVENUE,
      },
    ]
      .filter(({ privilege }) => privilege !== false)
      .map(({ label, value }, index) => ({
        label: `${index + 1}. ${label}`,
        value,
      }))
    const indicatorOptions = getColumnsPerRanking(ranking).map((column, index) => ({
      label: `${index + 1}. ${t(getLabelPerColumn(column))}`,
      value: column,
    }))

    return (
      <div className={classNames('rankings-box-filters', { 'filters-expanded': areFiltersExpanded })}>
        <Box className="flex-row rankings-box-filters_title cursor-pointer" onClick={toggleAreFiltersExpanded}>
          <div className="flex-column">{t(`rankings.${ranking}`)}</div>

          <div className="fm fm-dropdownlist" />
        </Box>

        <div className="filter-ranking">
          <InputDropdown label={t('rankings.title')} onChange={setRanking} options={rankingOptions} selectedValue={ranking} />

          <Box
            className="filter-countries cursor-pointer"
            onClick={() => {
              if (!countries.length) {
                fetchCountries()
              }

              openFilterCountryModal()
            }}
          >
            <div className="fm fm-filter" />

            {selectedCountriesCount > 0 && <div className="selected-countries-count">{selectedCountriesCount}</div>}
          </Box>
        </div>

        <div className="filter-indicator">
          <InputDropdown
            label={t('rankings.indicator')}
            onChange={setIndicator}
            options={indicatorOptions}
            selectedValue={indicator}
          />
        </div>

        {isModalOpen && <FilterCountryModalContainer onClose={hideFilterCountryModal} />}
      </div>
    )
  }
}

RankingsBoxFilters.propTypes = {
  areFiltersExpanded: PropTypes.bool.isRequired,
  countries: PropTypes.array,
  fetchCountries: PropTypes.func.isRequired,
  hideFilterCountryModal: PropTypes.func.isRequired,
  indicator: PropTypes.string.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  openFilterCountryModal: PropTypes.func.isRequired,
  ranking: PropTypes.string.isRequired,
  selectedCountriesCount: PropTypes.number,
  setIndicator: PropTypes.func.isRequired,
  setRanking: PropTypes.func.isRequired,
  toggleAreFiltersExpanded: PropTypes.func.isRequired,
  userPrivileges: PropTypes.object.isRequired,
  t: PropTypes.func,
}

export default withTranslation()(RankingsBoxFilters)
